import { render, staticRenderFns } from "./PostCreation_Bar.vue?vue&type=template&id=6d0bc035&scoped=true&"
import script from "./PostCreation_Bar.vue?vue&type=script&lang=js&"
export * from "./PostCreation_Bar.vue?vue&type=script&lang=js&"
import style0 from "./PostCreation_Bar.vue?vue&type=style&index=0&id=6d0bc035&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0bc035",
  null
  
)

export default component.exports